import styled from 'styled-components';

export const SubscriptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-left: 24px;

  h1 {
    font: 700 1.5rem/1.8rem 'Segoe UI', sans-serif;
  }
`;

export const SubscriptionsContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 20px;
  gap: 1rem;
`;
